import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function ServiceReports(){return <CompanyReportScreen kind="services"/>;}
